import React from "react";
import dataLineChart from "./data/linechart.json";
import { chartHelpers } from "./Charts";

import { Line } from "react-chartjs-2";

export class LineChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLineChart: chartHelpers.mergeColorsIntoData(this.props.data||dataLineChart)
    };
  }

  optionsLine() {
    return this.props.options||{
      legend: {
        display: false
      }
    }
  }

  render() {
    return (
      <Line
        ref="chart1"
        data={chartHelpers.mergeColorsIntoData(this.state.dataLineChart)}
        options={this.optionsLine()}
      />
    );
  }
}

export default LineChart;
